import React, { useEffect } from 'react';
import $ from 'jquery';
import * as R from "ramda";

import { DateWithModal } from '../../../../_common/dateWithModal';
import { fetchInvoiceLines, markPartnersInvoicesPaid } from '../../../../actions/backoffice/payments';
import { useDispatch } from 'react-redux';



export const PaiementPartnersTableRow = ({ amount, created, recipientType, paid, invoiceId, partnerName, etablissementName, pdfUrl, issuerId, isDueToAssista }) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dispatch = useDispatch();
    const options = { style: 'currency', currency: 'EUR' };



    return (
        <div className="card p-2 mt-1">
            <div className="row g-1 align-items-center">
                <div className="col text-truncate">
                    <div className={"h5 ls-1 my-auto text-truncate"}>{partnerName}</div>
                </div>
                <div className="col text-truncate">
                    {/* <div className={"h5 ls-1 my-auto text-truncate" + (recipientType === "Etablissement" ? "" : " o-50")}>{recipientType === "Etablissement" ? etablissementName : ""}</div> */}
                    <div className={"h5 ls-1 my-auto text-truncate"}>{!R.isNil(etablissementName) ? etablissementName : ""}</div>
                </div>
                <div className="col-auto col-md-2">
                    <div className="h5 ls-1 my-auto o-70 container-tiny">{new Intl.DateTimeFormat('fr-FR').format(created)}</div>
                </div>
                <div className="col text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto ">{isDueToAssista ? "" : new Intl.NumberFormat('fr-FR', options).format(amount / 1.2)}</div>
                </div>
                <div className="col-auto col-md text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{isDueToAssista ? new Intl.NumberFormat('fr-FR', options).format(amount) : ""}</div>
                </div>
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                {paid ?
                    <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
                        <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Paiement effectué</span></div>
                        <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary" onClick={() => dispatch(fetchInvoiceLines(invoiceId))}>
                            <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <div className="dropdown">
                            <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
                                {/* <button type="button" className="dropdown-item fs-3 px-2 rounded-sm" onClick={() => dispatch(markPartnersInvoicesPaid({ id: invoiceId, paid: false }))}><i className="eva eva-slash-outline align-middle fs-sm lh-1 mr-2 text-danger"></i><span className="align-middle o-70 o-100--hover">Marquer comme impayé</span></button> */}
                                {/* <div class="dropdown-divider"></div> */}
                                <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
                        <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
                        <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary" onClick={() => dispatch(fetchInvoiceLines(invoiceId))}>
                            <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <div className="dropdown">
                            <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
                                <button type="button" className="dropdown-item fs-3 px-2 rounded-sm" onClick={() => dispatch(markPartnersInvoicesPaid({ id: invoiceId, paid: true }))}><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
                                {/* <div class="dropdown-divider"></div> */}
                                <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>


    );
};





{/* <div className="card p-2 mt-1">
<div className="row gx-2 gy-1 align-items-center">
    <div className="col">
        <div className="h5 ls-1 my-auto text-truncate">Résidentiel Euro</div>
    </div>
    <div className="col">
        <div className="h5 ls-1 my-auto o-50 text-truncate">Résidentiel Euro</div>
    </div>
    <div className="col col-md-2">
        <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
    </div>
    <div className="col text-md-right">
        <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
    </div>
    <div className="col text-md-right">
        <div className="h5 ls-1 my-auto container-press ml-auto"></div>
    </div>
    <div className="col-12 d-md-none">
        <hr className="my-0" />
    </div>
    <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
        <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
        <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
            <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
        </button>
        <div className="dropdown">
            <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
                <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
                {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row gx-2 gy-1 align-items-center">
//     <div className="col">
//         <div className="h5 ls-1 my-auto text-truncate o-50">Résidentiel Euro</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto text-truncate">Paris</div>
//     </div>
//     <div className="col col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//         <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
//         <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//             <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//         </button>
//         <div className="dropdown">
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                 <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//             </button>
//             <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                 <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
//                 {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row gx-2 gy-1 align-items-center">
//     <div className="col">
//         <div className="h5 ls-1 my-auto text-truncate o-50">Résidentiel Euro</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto text-truncate">Lion</div>
//     </div>
//     <div className="col col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//         <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
//         <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//             <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//         </button>
//         <div className="dropdown">
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                 <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//             </button>
//             <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                 <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
//                 {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row g-1 align-items-center">
//     <div className="col text-truncate">
//         <div className={"h5 ls-1 my-auto text-truncate" + + (false ? " o-50" : "")}>Agences Funéraires</div>
//     </div>
//     <div className="col text-truncate">
//         <div className={"h5 ls-1 my-auto text-truncate" + (true ? " o-50" : "")}>Agences Funéraires</div>
//     </div>
//     <div className="col-auto col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-auto col-md text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     {true ?
//         <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//             <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Paiement effectué</span></div>
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//                 <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//             </button>
//             <div className="dropdown">
//                 <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                     <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//                 </button>
//                 <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                     <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-slash-outline align-middle fs-sm lh-1 mr-2 text-danger"></i><span className="align-middle o-70 o-100--hover">Marquer comme impayé</span></button>
//                     {/* <div class="dropdown-divider"></div> */}
//                     <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//                 </div>
//             </div>
//         </div>
//         :
//         <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//             <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//                 <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//             </button>
//             <div className="dropdown">
//                 <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                     <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//                 </button>
//                 <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                     <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
//                     {/* <div class="dropdown-divider"></div> */}
//                     <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//                 </div>
//             </div>
//         </div>
//     }
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row g-1 align-items-center">
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto o-50 text-truncate">Agences Funéraires</div>
//     </div>
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto text-truncate">Paris</div>
//     </div>
//     <div className="col-auto col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-auto col-md text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//         <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
//         <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//             <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//         </button>
//         <div className="dropdown">
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                 <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//             </button>
//             <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                 <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
//                 {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row g-1 align-items-center">
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto o-50 text-truncate">Agences Funéraires</div>
//     </div>
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto text-truncate">Lion</div>
//     </div>
//     <div className="col-auto col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-auto col-md text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//         <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Impayé</span></div>
//         <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//             <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//         </button>
//         <div className="dropdown">
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                 <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//             </button>
//             <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                 <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
//                 {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div>
// <div className="card p-2 mt-1">
// <div className="row g-1 align-items-center">
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto o-50 text-truncate">Agences Funéraires</div>
//     </div>
//     <div className="col text-truncate">
//         <div className="h5 ls-1 my-auto text-truncate">Nice</div>
//     </div>
//     <div className="col-auto col-md-2">
//         <div className="h5 ls-1 my-auto o-70 container-tiny">08/2021</div>
//     </div>
//     <div className="col">
//         <div className="h5 ls-1 my-auto container-press ml-auto"></div>
//     </div>
//     <div className="col-auto col-md text-md-right">
//         <div className="h5 ls-1 my-auto container-press ml-auto">formatAmount(invoice.amount) €</div>
//     </div>
//     <div className="col-12 d-md-none">
//         <hr className="my-0" />
//     </div>
//     <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
//         <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Paiement effectué</span></div>
//         <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary">
//             <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
//         </button>
//         <div className="dropdown">
//             <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//                 <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
//             </button>
//             <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
//                 <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-slash-outline align-middle fs-sm lh-1 mr-2 text-danger"></i><span className="align-middle o-70 o-100--hover">Marquer comme impayé</span></button>
//                 {/* <div class="dropdown-divider"></div> */}
//                 <a href={"#"} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Voir la facture</span></a>
//             </div>
//         </div>
//     </div>
// </div>
// </div> */}